module.exports = __webpack_public_path__ + "img/2023-19.3e9c7245.jpg";